import { Validators } from '@angular/forms';
import { ConfigurationType, IoKey } from 'apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import { AdditionalCall, FormInputType, SettingsFormData, SettingsFormInputData } from '../../components';
import { SettingsUnitsConverter } from '../../utils/SettingsUnitConverter';

export const x1x2SettingsDefinition: SettingsFormInputData[] = [
  {
    key: IoKey.INST_X1_1_ENABLE,
    type: FormInputType.TOGGLE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1a.options.toggle.description',
    title: 'kwa.settings.installer-settings.x1a.options.toggle.title',
    readOnly: false,
    listenOnChanges: true,
    accessibilityId: 'installer-settings-x1a-toggle',
  },
  {
    key: IoKey.INST_X1_1_MODE,
    type: FormInputType.SELECT,
    additionalCallType: AdditionalCall.INSTALLER_X1_1_MODE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1a.options.mode.description',
    title: 'kwa.settings.installer-settings.x1a.options.mode.title',
    readOnly: false,
    showDependentOnOtherSetting: { [IoKey.INST_X1_1_ENABLE]: 'true' },
    listenOnChanges: true,
    accessibilityId: 'installer-settings-x1a-mode',
    validators: [Validators.required],
    selectOptions: [],
    selectOptionKey: 'inst_settings_x1_1_modes',
    trimSelectOptions: true,
  },
  {
    key: IoKey.INST_X1_1_VALUE,
    type: FormInputType.NUMBER,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1a.options.value.description',
    title: 'kwa.settings.installer-settings.x1a.options.value.title',
    // only allow certain range: 0 and 6-32
    validators: [Validators.pattern(/^(0|([6-9]|[1-2][0-9]|3[0-2]))$/), Validators.required],
    showDependentOnOtherSetting: { [IoKey.INST_X1_1_ENABLE]: 'true', [IoKey.INST_X1_1_MODE]: 'LIMIT_CHARGING' },
    accessibilityId: 'installer-settings-x1a-value',
    convertToDisplayUnit: SettingsUnitsConverter.milliAmpereToAmpere,
    convertFromDisplayUnit: SettingsUnitsConverter.ampereToMilliAmpere,
  },
  {
    key: IoKey.INST_X1_1_INVERTED,
    type: FormInputType.TOGGLE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1a.options.inverted.description',
    title: 'kwa.settings.installer-settings.x1a.options.inverted.title',
    readOnly: false,
    accessibilityId: 'installer-settings-x1a-inverted',
    hasSeparator: true,
    showDependentOnOtherSetting: { [IoKey.INST_X1_1_ENABLE]: 'true' },
  },
  {
    key: IoKey.INST_X1_2_ENABLE,
    type: FormInputType.TOGGLE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1b.options.toggle.description',
    title: 'kwa.settings.installer-settings.x1b.options.toggle.title',
    readOnly: false,
    listenOnChanges: true,
    accessibilityId: 'installer-settings-x1b-toggle',
  },
  {
    key: IoKey.INST_X1_2_MODE,
    type: FormInputType.SELECT,
    additionalCallType: AdditionalCall.INSTALLER_X1_2_MODE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1b.options.mode.description',
    title: 'kwa.settings.installer-settings.x1b.options.mode.title',
    readOnly: false,
    showDependentOnOtherSetting: { [IoKey.INST_X1_2_ENABLE]: 'true' },
    listenOnChanges: true,
    accessibilityId: 'installer-settings-x1b-mode',
    validators: [Validators.required],
    selectOptions: [],
    selectOptionKey: 'inst_settings_x1_2_modes',
    trimSelectOptions: true,
  },
  {
    key: IoKey.INST_X1_2_VALUE,
    type: FormInputType.NUMBER,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1b.options.value.description',
    title: 'kwa.settings.installer-settings.x1b.options.value.title',
    // only allow certain range: 0 and 6-32
    validators: [Validators.pattern(/^(0|([6-9]|[1-2][0-9]|3[0-2]))$/), Validators.required],
    showDependentOnOtherSetting: { [IoKey.INST_X1_2_ENABLE]: 'true', [IoKey.INST_X1_2_MODE]: 'LIMIT_CHARGING' },
    accessibilityId: 'installer-settings-x1b-value',
    convertToDisplayUnit: SettingsUnitsConverter.milliAmpereToAmpere,
    convertFromDisplayUnit: SettingsUnitsConverter.ampereToMilliAmpere,
  },
  {
    key: IoKey.INST_X1_2_INVERTED,
    type: FormInputType.TOGGLE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x1b.options.inverted.description',
    title: 'kwa.settings.installer-settings.x1b.options.inverted.title',
    readOnly: false,
    accessibilityId: 'installer-settings-x1b-inverted',
    showDependentOnOtherSetting: { [IoKey.INST_X1_2_ENABLE]: 'true' },
  },
  {
    key: IoKey.INST_X2_ENABLE,
    type: FormInputType.TOGGLE,
    additionalCallType: AdditionalCall.INSTALLER_X2_MODE,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x2.options.toggle.description',
    title: 'kwa.settings.installer-settings.x2.options.toggle.title',
    listenOnChanges: true,
    accessibilityId: 'installer-settings-x2-toggle',
    toggleServiceKey: 'kw.flags.showX2Settings',
  },
  {
    key: IoKey.INST_X2_MODE,
    type: FormInputType.SELECT,
    configurationType: ConfigurationType.IO,
    description: 'kwa.settings.installer-settings.x2.options.mode.description',
    title: 'kwa.settings.installer-settings.x2.options.mode.title',
    showDependentOnOtherSetting: { [IoKey.INST_X2_ENABLE]: 'true' },
    accessibilityId: 'installer-settings-x2-mode',
    validators: [Validators.required],
    listenOnChanges: true,
    selectOptionKey: 'inst_settings_x2_modes',
    toggleServiceKey: 'kw.flags.showX2Settings',
    trimSelectOptions: true,
  },
];

export const x1x2FormDefinition: SettingsFormData[] = [
  {
    elements: [...x1x2SettingsDefinition],
  },
];
